import { buildSelector } from 'shared/lib/store';

export const [useThemeData, getThemeData] = buildSelector(
    (state) => state.theme.mode
);
